import React from 'react';
import styles from './separator.module.scss';

const Separator = () => <div className={styles.separator} />;

export default Separator;
